export default function put(key: string, value: any, prefix = '') {
  localStorage[`${prefix}${key}`] = JSON.stringify(value);
}
